import React from 'react';
import { Accordion } from '../ui/Accordion';
import { AnimatedSection } from './AnimatedSection';
import { faqs } from './homeData';
export function FaqSection() {
  return <AnimatedSection className="py-8 sm:py-24 bg-slate-50" data-id="element-16335">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16336">
        <div className="text-center mb-5 sm:mb-12" data-id="element-16337">
          <h2 className="text-lg sm:text-3xl font-bold text-slate-900 mb-2 sm:mb-4" data-id="element-16338">
            Частые вопросы
          </h2>
          <p className="text-xs sm:text-lg text-slate-500" data-id="element-16339">
            Всё, что нужно знать перед заказом
          </p>
        </div>
        <Accordion items={faqs} data-id="element-16340" />
      </div>
    </AnimatedSection>;
}